import React, { useState } from 'react'

import { useStaticQuery, graphql } from 'gatsby'

import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Button from 'react-bootstrap/Button'

import Team from '../images/svg/team.svg'
import HolisticAssessment from '../images/svg/holistic-assess.svg'
import Roadmap from '../images/svg/map.svg'
import Collaborative from '../images/svg/collaborative.svg'
import Review from '../images/svg/review.svg'
import HappyTeam from '../images/svg/happy-team.svg'
import MyModal from './components/MyModal'

const Teams = () => {

    const [ modalKey, setModalKey ] = useState(1)
    const [ modalShow, setModalShow ] = useState(false)

    const data = useStaticQuery(graphql`
        query {
            allContentfulTeams{
                edges{
                    node{
                        title
                        teamsTagline
                        button1Title
                        button2Title
                        button3Title
                        button4Title
                        button5Title
                        button6Title
                        teamsCallToActionHeader
                        teamsCallToActionHeaderKeyword
                        teamsCallToActionButton
                        teamsSecondaryCallToActionButton
                        }
                    }
            }
        }
        `)    

        const { title, 
                teamsTagline, 
                button1Title,
                button2Title,
                button3Title,
                button4Title,
                button5Title,
                button6Title,
                teamsCallToActionHeader,
                teamsCallToActionHeaderKeyword,
                teamsCallToActionButton,
                teamsSecondaryCallToActionButton } = data.allContentfulTeams.edges[0].node

        const handleModalClick = ( key, modalShow ) => {
            setModalKey(key)
            setModalShow(!modalShow)
        }

        const handleModalClose = () => {
            setModalShow(false)
        }

        const onNextClick = ( key ) => {
            handleModalClose()
            if(key > 6) {
                setTimeout(() => {window.location=('#contact')}, 500)
                console.log(`the last one`)
            } else {
               handleModalClick(key, false)
            }
        }

    return (
        <section id="teams" className="py-5 second-bg-color">
            <Container className="pt-5">
                <h1
                className="d-none d-md-block display-4 font-weight-bolder text-center text-success text-uppercase pt-5"
                >
                    {title}
                </h1>
                <h2
                    className="d-sm-block d-md-none d-lg-none d-xl-none font-weight-bolder text-center text-success text-uppercase py-5"
                >
                    {title}
                </h2>

                <h1 className="d-none d-md-block font-weight-bolder text-center text-secondary text-uppercase pt-3">{teamsTagline}</h1>

                <Row id="teamsRow" className="large-row my-5">

                <Col sm="12" md="4" lg="2" className="oddButton text-center p-0">

                    <h5 className="d-none d-lg-block my-2 font-weight-bolder text-secondary text-uppercase">
                        {button1Title}
                    </h5>

                    <Button
                    variant="light"
                    id="immersionButton"
                    onClick={() => handleModalClick(1, modalShow)}
                    className="rounded-circle bg-light btn-shadow call-to-action"
                    >
                        <Team alt="team" className="img img-fluid p-4" />
                    </Button>

                    <h5 className="d-block d-lg-none d-xl-none my-2 font-weight-bolder text-secondary text-uppercase">
                    {button1Title}
                    </h5>
                </Col>

                <Col sm="12" md="4" lg="2"
                    className="evenButton text-center p-0 align-self-end"
                >
                    <Button
                    variant="light"
                    id="holisticButton"
                    onClick={() => handleModalClick(2, modalShow)}
                    className="rounded-circle bg-light btn-shadow call-to-action"
                    >
                        <HolisticAssessment
                            alt="holistic assessment"
                            className="img img-fluid p-4"
                        />
                    </Button>
                    <h5 className="my-2 font-weight-bolder text-secondary text-uppercase">
                        {button2Title}
                    </h5>
                </Col>

                <Col sm="12" md="4" lg="2" className="oddButton text-center p-0">
                    <h5 className="d-none d-lg-block my-2 font-weight-bolder text-secondary text-uppercase">
                        {button3Title}
                    </h5>

                    <Button
                    variant="light"
                    type="button"
                    onClick={() => handleModalClick(3, modalShow)}
                    className="rounded-circle bg-light btn-shadow call-to-action"
                    >
                        <Roadmap alt="map" className="img img-fluid p-4" />
                    </Button>

                    <h5 className="d-block d-lg-none d-xl-none my-2 font-weight-bolder text-secondary text-uppercase">
                        {button3Title}
                    </h5>
                </Col>

                <div
                    className="evenButton text-center col-sm-12 col-md-4 col-lg-2 p-0 align-self-end"
                >
                    <Button
                    variant="light"
                    type="button"
                    onClick={() => handleModalClick(4, modalShow)}
                    className="rounded-circle bg-light btn-shadow call-to-action"
                    >
                        <Collaborative
                            alt="collaboration"
                            className="img img-fluid p-4"
                        />
                    </Button>

                    <h5 className="my-2 font-weight-bolder text-secondary text-uppercase">
                        {button4Title}
                    </h5>
                </div>

                <Col sm="12" md="4" lg="2" className="oddButton text-center p-0">
                    <h5 className="d-none d-lg-block my-2 font-weight-bolder text-secondary text-uppercase">
                        {button5Title}
                    </h5>

                    <Button
                    variant="light"
                    type="button"
                    onClick={() => handleModalClick(5, modalShow)}
                    className="rounded-circle bg-light btn-shadow call-to-action"
                    >
                        <Review
                            alt="review"
                            className="img img-fluid p-4"
                        />
                    </Button>

                    <h5 className="d-block d-lg-none d-xl-none my-2 font-weight-bolder text-secondary text-uppercase">
                        {button5Title}
                    </h5>
                </Col>


                <Col sm="12" md="4" lg="2"
                    className="text-center p-0 align-self-end"
                >
                    <Button
                    variant="light"
                    type="button"
                    onClick={() => handleModalClick(6, modalShow)}
                    className="rounded-circle bg-light btn-shadow call-to-action"
                    >
                    <HappyTeam
                        alt="happy teams"
                        className="img img-fluid p-4"
                    />
                    </Button>
                    <h5 className="my-2 font-weight-bolder text-secondary text-uppercase">{button6Title}</h5>
                </Col>
            </Row>

        <Row className="large-row my-5 align-items-center">
          <Col sm="12" md="5" className="d-flex text-center">
                <h3 className="mb-0 font-weight-bolder text-uppercase">
                    {teamsCallToActionHeader && 
                        teamsCallToActionHeader.split(/[ ,]+/).map(word => {
                            if (teamsCallToActionHeaderKeyword === word)
                                return (
                                    <span key={word} className='underline'>
                                        {`${word} `}
                                    </span>
                                )
                                return (
                                        `${word} ` 
                                )
                        })
                    } 
                </h3>
          </Col>

          <Col sm="12" md="7" className="d-flex align-content-center justify-content-center">
              <Button variant="warning"  href="#contact" className="btn-lg btn-shadow font-weight-bolder inner-link mr-3">
                <h3 className="font-weight-bolder m-0 text-uppercase">{teamsCallToActionButton}</h3>
              </Button>
           
              <Button variant="success"  href="#leaders"
                className="btn-lg btn-shadow font-weight-bolder next-link2"
              >
                <h3 className="font-weight-bolder text-uppercase m-0">{teamsSecondaryCallToActionButton}</h3>
              </Button>
          </Col>
        </Row>
      </Container>

    <MyModal modalShow={modalShow} modalKey={modalKey} onHide={handleModalClose} onNextClick={onNextClick} />

    </section>
    )
}

export default Teams
